import { z } from "zod";
import { i18nMessage } from "@/lib/i18nMessage";

export const OtherFeesSchema = z.object({
  otherEuFees: z.object({
    otherFeesRange: z
      .array(
        z.object({
          amount: z
            .number({
              coerce: true,
              message: i18nMessage("shared:forms.otherFees.amountInvalid"),
            })
            .min(0, i18nMessage("shared:forms.otherFees.amountPositive")),
          quantity: z
            .number({
              coerce: true,
              message: i18nMessage("shared:forms.otherFees.quantityInvalid"),
            })
            .min(0, i18nMessage("shared:forms.otherFees.quantityPositive")),
          id: z.string().min(1),
        }),
      )
      .min(1, i18nMessage("shared:forms.otherFees.feesRequired")),
  }),
  otherNonEuFees: z.object({
    otherFeesRange: z
      .array(
        z.object({
          amount: z
            .number({
              coerce: true,
              message: i18nMessage("shared:forms.otherFees.amountInvalid"),
            })
            .min(0, i18nMessage("shared:forms.otherFees.amountPositive")),
          quantity: z
            .number({
              coerce: true,
              message: i18nMessage("shared:forms.otherFees.quantityInvalid"),
            })
            .min(0, i18nMessage("shared:forms.otherFees.quantityPositive")),
          id: z.string().min(1),
        }),
      )
      .min(1, i18nMessage("shared:forms.otherFees.feesRequired")),
  }),
  otherUsaFees: z.object({
    otherFeesRange: z
      .array(
        z.object({
          amount: z
            .number({
              coerce: true,
              message: i18nMessage("shared:forms.otherFees.amountInvalid"),
            })
            .min(0, i18nMessage("shared:forms.otherFees.amountPositive")),
          quantity: z
            .number({
              coerce: true,
              message: i18nMessage("shared:forms.otherFees.quantityInvalid"),
            })
            .min(0, i18nMessage("shared:forms.otherFees.quantityPositive")),
          id: z.string().min(1),
        }),
      )
      .min(1, i18nMessage("shared:forms.otherFees.feesRequired")),
  }),
});

export type OtherFeesData = z.infer<typeof OtherFeesSchema>;
